import bottle from '../assets/rewards/bottle.jpg';
import cutlery from '../assets/rewards/cutlery.png';
import fan from '../assets/rewards/fan.jpg';
// import humidifier from '../assets/rewards/humidifier.jpeg';
import notebookpen from '../assets/rewards/notebookpen.jpeg';
import shoepouch from '../assets/rewards/shoepouch.jpg';
import totebag from '../assets/rewards/totebag.jpg';
import umbrella from '../assets/rewards/umbrella.jpg';

export const rewards = [
    {
        id: 1,
        imageUrl: totebag,
        title: "Cotton Tote Bag",
        description: "A stylish and eco-friendly cotton tote bag that's perfect for your daily essentials. Lightweight, durable, and reusable - take it anywhere!",
        coins: 100,
    },
    {
        id: 2,
        imageUrl: shoepouch,
        title: "Shoe Pouch",
        description: "Keep your shoes clean and organized with this compact, travel-friendly shoe pouch. Ideal for gym sessions or weekend getaways!",
        coins: 200,
    },
    {
        id: 3,
        imageUrl: umbrella,
        title: "Umbrella",
        description: "Stay dry in style! This sleek and sturdy umbrella is designed to protect you from the elements.",
        coins: 200,
    },
    {
        id: 4,
        imageUrl: notebookpen,
        title: "Notebook and Pen",
        description: "Elevate your note-taking with this eco-friendly notebook and pen set. Made for the modern thinker, it's perfect for jotting down ideas, plans, and inspiration.",
        coins: 200,
    },
    {
        id: 5,
        imageUrl: cutlery,
        title: "Bamboo Cutlery Box",
        description: "Make every meal more sustainable with this bamboo cutlery set. Portable, stylish, and perfect for reducing single-use plastics on the go!",
        coins: 300,
    }, 
    // {
    //     id: 6,
    //     imageUrl: humidifier,
    //     title: "Humidifier",
    //     description: "Bring comfort to your space with this sleek, compact humidifier. Add moisture to the air and create a relaxing environment, wherever you are.",
    //     coins: 400,
    // },
    {
        id: 7,
        imageUrl: fan,
        title: "Fan",
        description: "Stay cool with this portable fan, designed for maximum comfort and convenience. Whether at home, the office, or outdoors, it's your go-to for a breeze of fresh air.",
        coins: 400,
    },
    {
        id: 8,
        imageUrl: bottle,
        title: "Reusable Water Bottle",
        description: "Hydrate sustainably with this sleek reusable water bottle. Keep your drinks cold or hot while reducing plastic waste - a win for you and the planet!",
        coins: 500,
    }
];
